export function mv() {
  window.addEventListener("load", () => {
    const persons = document.querySelectorAll(".js-person");
    const mv = document.querySelector(".js-mv");

    persons.forEach(person => {
      person.classList.add("is-animated");
    })

    mv.classList.add("is-animated");
  })
}
